import { ResetPassword } from "./views/reset-password/reset-password";
import { CreateNewPassword } from "./views/create-new-password/create-new-password";
import { ConfirmLogout } from "./views/confirm-logout/confirm-logout";

import { Create } from "./views/create/create";
import { Login } from "./views/login/login";
import { ErrorRoute } from "./views/error/error";
import { SelectOrg } from "./views/select-org/select-org";
import { RequestInvitation } from "./views/request-invitation/request-invitation";
export interface Route {
    path: string;
    component: Function;
    nav?: string;
}

// Routes with a "nav" property will create a tab on the
// Product Bar (top-level navigation bar for the app)
export const ROUTES: Array<Route> = [
    {
        path: "/confirm-logout",
        component: ConfirmLogout,
    },
    {
        path: "/reset-password",
        component: ResetPassword,
    },
    {
        path: "/create-new-password",
        component: CreateNewPassword,
    },
    {
        path: "/create",
        component: Create,
    },
    {
        path: "/request-invitation",
        component: RequestInvitation,
    },
    {
        path: "/login",
        component: Login,
    },
    {
        path: "/error",
        component: ErrorRoute,
    },
    {
        path: "/select-org",
        component: SelectOrg,
    },
];
